import { createSelector } from 'reselect'

import { isCanonicalFinSobRow } from '../../lib/revenueAndSob/isCanonicalFinSobRow'

import { selectEnrichedCockpitFinSobRows } from './selectEnrichedCockpitFinSobRows'

export const selectCanonicalCockpitFinSobRows = createSelector(
  [selectEnrichedCockpitFinSobRows],
  (rows) => rows.filter(isCanonicalFinSobRow)
)
